import './utils/cspReporter.ts';
import '@babel/polyfill';
import 'event-propagation-path';

import { Suspense } from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import App from './App.tsx';
import { setupDeviceEventsClient } from './modules/devices/utils/deviceEventsBootstrap.util.ts';
import { setupShippoPrint } from './modules/print/utils/bootstrap.util.ts';
import setupStore, { history } from './store.ts';
import { ShippoTools } from './utils/browser-tools.tsx';

if (CONFIG.showTools) new ShippoTools();

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

const store = setupStore(preloadedState);

// Segment initialization
const loadSegment = () => {
  if (analytics && CONFIG.segment) {
    analytics.load(CONFIG.segment, {
      integrations: {
        'Segment.io': {
          deliveryStrategy: {
            config: {
              size: 25,
              timeout: 1000,
            },
            strategy: 'batching',
          },
        },
      },
    });
  }
};

setupDeviceEventsClient();
setupShippoPrint();

const runApp = () => {
  window.stackables = [];

  loadSegment();

  // eslint-disable-next-line react/no-render-return-value
  return ReactDOM.render(
    <Suspense fallback="">
      <Provider store={store}>
        <App history={history} />
      </Provider>
    </Suspense>,
    document.getElementById('appContent'),
  );
};

runApp();
